import { z } from "zod"
import { Pagination } from "../../_kernel/Pagination"
import { Poap } from "./Poap"
import { PoapAssetsSchema, type PoapAssetsType } from "@tutellus/schemas"

export const PoapListValidation = z.object({
  items: z.array(z.instanceof(Poap)),
  pagination: z.instanceof(Pagination),
})

export class PoapList {
  constructor(
    private readonly _items: Poap[],
    private readonly _pagination: Pagination,
  ) {}

  static create({ items, pagination }: z.infer<typeof PoapListValidation>) {
    const { error, success } = PoapListValidation.safeParse({ items, pagination })
    if (!success) throw new Error(error.message)
    return new PoapList(items, pagination)
  }

  static createFromAPI(data: PoapAssetsType) {
    const { error, success } = PoapAssetsSchema.safeParse(data)
    if (!success) throw new Error(`Invalid PoapAssets data: ${error.message}`)

    const items = data.items.map((item) => Poap.createFromAPI(item))
    const pagination = Pagination.createFromAPI(data.metadata)
    return PoapList.create({ items, pagination })
  }

  static empty() {
    return new PoapList([], Pagination.createDefault({ orderBy: "createdAt" }))
  }

  get items() { return this._items } // prettier-ignore
  get pagination() { return this._pagination } // prettier-ignore
  get isEmpty() { return this._items.length === 0 } // prettier-ignore

  getTokenId({ poapId }: { poapId: string }): number | null {
    const poap = this._items.find((p) => p.id === poapId)
    return poap?.tokenId ?? null
  }

  serialize() {
    return {
      items: this._items.map((poap) => poap.serialize()),
      pagination: this._pagination.serialize(),
    }
  }
}

export type PoapListSerialized = ReturnType<PoapList["serialize"]>
